// 手機版發文按鈕
import { useSelector } from 'react-redux';
import { urlState } from '@/slices/urlSlice';
import Image from 'next/image';

const MenuPostButton = ({ t }) => {
    const { forumUrl } = useSelector(urlState);

    return (
        <div className="hidden ulg:block pt-[22px] border-t-1 border-purple1 border-dashed border-opacity-[.4]">
            <a
                href={forumUrl + '/post'}
                target="_blank"
                rel="noreferrer noopener"
                className="center-center group w-full relative rounded-[40px] h-[46px] overflow-hidden bg-bou"
            >
                <Image
                    className="set-center w-full h-full !z-0 trans group-hover:opacity-0 !object-cover object-center"
                    width={54}
                    height={54}
                    src="/images/layout/post_bg.png"
                    alt="background"
                />
                <Image
                    className="relative !z-[1] aspect-[1] trans group-hover:rotate-[-15deg] group-hover:scale-[1.1] ulg:w-[16px]"
                    width={20}
                    height={20}
                    src="/images/icon/icon_post.svg"
                    alt="icon"
                />

                <span className="inline-block pl-[10px] text-[#fff] text-btn2 relative z-[2]">
                    {t('POST')}
                </span>
            </a>
        </div>
    );
};

export default MenuPostButton;
